
export enum SharePointReportProfileDriveItemRole {
  Unknown = 0,
  Read = 1,
  Write = 2,
  Owner = 4
}
